import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowRight, X } from 'lucide-react';
import TripDetailsForm from './TripDetailsForm';
import ContactInfoForm from './ContactInfoForm';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const BookingForm = ({ formState, onFormChange, onSubmit, isSubmitting }) => {
  return (
    <form onSubmit={onSubmit} className="lg:col-span-2">
      <Card className="bg-brand-charcoal border-brand-gold/20 p-4 sm:p-6 lg:p-8">
        <CardHeader className="pb-4 sm:pb-6">
          <CardTitle className="text-2xl sm:text-3xl font-serif text-white">Trip Details</CardTitle>
        </CardHeader>
        
        {/* Airport Service Notice - Left Side Only */}
        <div className="mb-6 p-4 bg-gradient-to-r from-blue-900/40 to-blue-800/40 border-2 border-blue-400/60 rounded-lg">
          <div className="flex items-center gap-3">
            <div className="text-2xl">✈️</div>
            <div>
              <p className="text-blue-300 font-bold text-lg mb-1">
                Airport Services Available!
              </p>
              <p className="text-blue-200 text-sm">
                For airport pickups/drop-offs, call us at <span className="font-bold text-blue-100">(703) 843-1837</span> for specialized pricing and scheduling.
              </p>
            </div>
          </div>
        </div>
        
        <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          <TripDetailsForm formState={formState} onFormChange={onFormChange} />
          
          <div className="md:col-span-2 border-t border-brand-gold/20 pt-4 sm:pt-6">
            <CardTitle className="text-xl sm:text-2xl font-serif text-white mb-4">Contact Information</CardTitle>
            <ContactInfoForm formState={formState} onFormChange={onFormChange} />
          </div>

          <div className="md:col-span-2">
            <Label htmlFor="instructions" className="text-base sm:text-lg">Special Instructions</Label>
            <Input 
              id="instructions" 
              name="instructions"
              placeholder="Type any special request here (e.g., 'Please call on arrival')" 
              className="mt-2 h-10 sm:h-12 text-base sm:text-lg" 
              value={formState.instructions} 
              onChange={(e) => onFormChange('instructions', e.target.value)} 
              onClear={() => onFormChange('instructions', '')}
              autoComplete="off"
            />
          </div>

          <div className="md:col-span-2">
            <Button type="submit" size="lg" className="w-full bg-brand-gold text-brand-dark hover:bg-yellow-500 font-bold text-lg sm:text-xl py-4 sm:py-6 lg:py-7" disabled={isSubmitting}>
              {isSubmitting ? 'Sending Request...' : 'Request Booking'} <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
            </Button>
          </div>
        </CardContent>
      </Card>
    </form>
  );
};

export default BookingForm;